import { useEffect, useRef } from 'react';
import { EffectCallback, UseEffectReturn } from './type.effect.js';

/**
 * React effect hook that invokes only one time only if the `dep` value is defined
 * @param dep any
 */
export const useEffectOnce = (
  effect: EffectCallback,
  dep?
): UseEffectReturn => {
  const executed = useRef(false);
  useEffect(() => {
    if (dep && !executed.current) {
      executed.current = true;
      return effect();
    }
  }, [dep]);
};
